

export const EMPLOYEES_BIRTHDAYS_CLEAN = "EMPLOYEES_BIRTHDAYS_CLEAN";
export const EMPLOYEES_BIRTHDAYS = "EMPLOYEES_BIRTHDAYS";
export const EMPLOYEES_BIRTHDAYS_CURRENT = "EMPLOYEES_BIRTHDAYS_CURRENT";
export const EMPLOYEE_PAYMENT_SLIPS_ONE = "EMPLOYEE_PAYMENT_SLIPS_ONE";
export const EMPLOYEE_PAYMENT_SLIPS_TWO = "EMPLOYEE_PAYMENT_SLIPS_TWO";
export const EMPLOYEE_PAYMENT_SLIPS_THREE = "EMPLOYEE_PAYMENT_SLIPS_THREE";
export const EMPLOYEES_ANNIVERSARY = "EMPLOYEES_ANNIVERSARY";


export const EMPLOYEE_VACATIONS = "EMPLOYEE_VACATIONS";

export const EMPLOYEE_RECORDS_ONE = "EMPLOYEE_RECORDS_ONE";
export const EMPLOYEE_RECORDS_TWO = "EMPLOYEE_RECORDS_TWO";
export const EMPLOYEE_RECORDS_THREE = "EMPLOYEE_RECORDS_THREE";

export const EMPLOYEE_CONTRACTS_ONE = "EMPLOYEE_CONTRACTS_ONE";
export const EMPLOYEE_CONTRACTS_TWO = "EMPLOYEE_CONTRACTS_TWO";
export const EMPLOYEE_CONTRACTS_THREE = "EMPLOYEE_CONTRACTS_THREE";

export const EMPLOYEE_LOANS_ONE = "EMPLOYEE_LOANS_ONE";
export const EMPLOYEE_LOANS_TWO = "EMPLOYEE_LOANS_TWO";
export const EMPLOYEE_LOANS_THREE = "EMPLOYEE_LOANS_THREE";
export const EMPLOYEE_LOANS_TYPES = "EMPLOYEE_LOANS_TYPES";
export const EMPLOYEE_LOANS_CURRENCIES = "EMPLOYEE_LOANS_CURRENCIES";
export const EMPLOYEE_LOAN_DETAILS = "EMPLOYEE_LOAN_DETAILS";
export const EMPLOYEE_LOAN_REQUEST = "EMPLOYEE_LOAN_REQUEST";
export const EMPLOYEE_LOAN_PERIOD = "EMPLOYEE_LOAN_PERIOD";
export const EMPLOYEE_LOAN_CANCEL_RESULT = "EMPLOYEE_LOAN_CANCEL_RESULT";
export const EMPLOYEE_LOAN_UPDATE_NOTE = "EMPLOYEE_LOAN_UPDATE_NOTE";

export const PAYMENT_SLIP_DOCUMENT_SIGNATURE_REQUEST = "PAYMENT_SLIP_DOCUMENT_SIGNATURE_REQUEST";
export const RECORD_DOCUMENT_SIGNATURE_REQUEST = "RECORD_DOCUMENT_SIGNATURE_REQUEST";
export const DOCUMENT_SIGNATURE_REQUEST = "DOCUMENT_SIGNATURE_REQUEST";
export const CONTRACT_DOCUMENT_SIGNATURE_REQUEST = "CONTRACT_DOCUMENT_SIGNATURE_REQUEST";
export const CONTRACT_OBSERVATION = "CONTRACT_OBSERVATION";
export const COUPON_RANGE_VALIDATION = "COUPON_RANGE_VALIDATION";
export const COUPON_REQUEST_RESPONSIBLE_EMAILS = "COUPON_REQUEST_RESPONSIBLE_EMAILS";
export const GET_EMPLOYEE_INFORMATION = "GET_EMPLOYEE_INFORMATION";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const GET_EMPLOYEE_RIGHT_HOLDERS = "GET_EMPLOYEE_RIGHT_HOLDERS";
export const UPDATE_EMPLOYEE_RIGHT_HOLDERS = "UPDATE_EMPLOYEE_RIGHT_HOLDERS";
export const SET_EMPLOYEE_TRAINING = "SET_EMPLOYEE_TRAINING";
export const GET_EMPLOYEE_TRAINING = "GET_EMPLOYEE_TRAINING";
export const GET_COLLEGES = "GET_COLLEGES";
export const GET_CONTACTS = "GET_CONTACTS";
export const GET_STAFF_POSITIONS = "GET_STAFF_POSITIONS";
export const GET_HEALTH_PLAN = "GET_HEALTH_PLAN";
export const GET_VACATIONS_RESUME = "GET_VACATIONS_RESUME";
export const APPROVAL_GROUPS_COMPANIES = "APPROVAL_GROUPS_COMPANIES";
export const USER_ASSIGNED_COMPANIES = "USER_ASSIGNED_COMPANIES";
export const APPROVAL_RESPONSABLES = "APPROVAL_RESPONSABLES";
export const COMPANY_EMPLOYEES = "COMPANY_EMPLOYEES";
export const APPROVAL_EMPLOYEES = "APPROVAL_EMPLOYEES";
export const APPROVE_COUPON = "APPROVE_COUPON";
export const CANCEL_APPROVED_COUPON = "CANCEL_APPROVED_COUPON";
export const EMPLOYEES_VACATIONS_RESUME = "EMPLOYEES_VACATIONS_RESUME";
export const GET_YEAR_HOLIDAYS = "GET_YEAR_HOLIDAYS";



export const PENDING_COUPONS_EMPLOYEES_ONE = "PENDING_COUPONS_EMPLOYEES_ONE";
export const PENDING_COUPONS_EMPLOYEES_TWO = "PENDING_COUPONS_EMPLOYEES_TWO";
export const PENDING_COUPONS_EMPLOYEES_THREE = "PENDING_COUPONS_EMPLOYEES_THREE";

export const PENDING_COUPONS_EMPLOYEES_HISTORY_ONE = "PENDING_COUPONS_EMPLOYEES_HISTORY_ONE";
export const PENDING_COUPONS_EMPLOYEES_HISTORY_TWO = "PENDING_COUPONS_EMPLOYEES_HISTORY_TWO";
export const PENDING_COUPONS_EMPLOYEES_HISTORY_THREE = "PENDING_COUPONS_EMPLOYEES_HISTORY_THREE";

export const COUPONS_TO_MY_CHARGE_HISTORY_ONE = "COUPONS_TO_MY_CHARGE_HISTORY_ONE";
export const COUPONS_TO_MY_CHARGE_HISTORY_TWO = "COUPONS_TO_MY_CHARGE_HISTORY_TWO";
export const COUPONS_TO_MY_CHARGE_HISTORY_THREE = "COUPONS_TO_MY_CHARGE_HISTORY_THREE";


export const LOANS_TO_MY_CHARGE_HISTORY_ONE = "LOANS_TO_MY_CHARGE_HISTORY_ONE";
export const LOANS_TO_MY_CHARGE_HISTORY_TWO = "LOANS_TO_MY_CHARGE_HISTORY_TWO";
export const LOANS_TO_MY_CHARGE_HISTORY_THREE = "LOANS_TO_MY_CHARGE_HISTORY_THREE";

export const LOANS_TO_MY_CHARGE_UPDATE_STATUS_ONE = "LOANS_TO_MY_CHARGE_UPDATE_STATUS_ONE";
export const LOANS_TO_MY_CHARGE_UPDATE_STATUS_TWO = "LOANS_TO_MY_CHARGE_UPDATE_STATUS_TWO";
export const LOANS_TO_MY_CHARGE_UPDATE_STATUS_THREE = "LOANS_TO_MY_CHARGE_UPDATE_STATUS_THREE";



export const IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE = "IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE";
export const IN_MY_CHARGE_EMPLOYEES_CONTRACTS_TWO = "IN_MY_CHARGE_EMPLOYEES_CONTRACTS_TWO";
export const IN_MY_CHARGE_EMPLOYEES_CONTRACTS_THREE = "IN_MY_CHARGE_EMPLOYEES_CONTRACTS_THREE";

export const IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE = "IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE";
export const IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_TWO = "IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_TWO";
export const IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_THREE = "IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_THREE";


export const IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_SCHEME_TYPES = "IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_SCHEME_TYPES";

export const IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE = "IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE";
export const IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_TWO = "IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_TWO";
export const IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_THREE = "IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_THREE";

export const BANK_ACCOUNTS_CONFIG = "BANK_ACCOUNTS_CONFIG";
export const BANK_ACCOUNTS_LIST = "BANK_ACCOUNTS_LIST";
export const BANKS_LIST = "BANKS_LIST";
export const BANK_ACCOUNT_ADD = "BANK_ACCOUNT_ADD";
export const BANK_ACCOUNT_UPDATE = "BANK_ACCOUNT_UPDATE";
export const BANK_ACCOUNT_DELETE = "BANK_ACCOUNT_DELETE";
export const CURRENCIES_LIST_GENERIC = "CURRENCIES_LIST_GENERIC";